<template>
  <div class="register-page withShadow login-page">
    <pageHeader />
    <div class="regesterComp section-pad">
      <div class="container">
        <div class="col-md-7 col-12 margin-auto">
          <h6 class="font-bold text-center mb-3">
            {{ $t("auth.registernew") }}
          </h6>
          <p class="gray-col text-center mb-3 font14">
            {{ $t("auth.registernewphase") }}
          </p>
          <v-form @submit.prevent="ValidRegister" v-model="valid" ref="form">
            <div class="flex-group-me mb-4">
              <div class="profile-img-cont">
                <img :src="profileImg" alt="" class="profileImg" />
                <input
                  name="image"
                  type="file"
                  id="imageInput"
                  hidden
                  accept="image/*"
                  @change="uploadImage"
                />
                <label for="imageInput" class="labelImg">
                  <i class="fa-regular fa-pen-to-square"></i>
                </label>
              </div>
            </div>
            <div class="flex-group-me mb-4">
              <div class="flex-big-gap">
                <div class="all-container-type">
                  <h6 class="mb-3 requiredInputLabel">{{ $t("auth.accountType") }}</h6>
                  <div class="flex-sm-gap">
                    <input
                      type="radio"
                      id="company"
                      checked
                      value="company"
                      ref="company"
                      name="type"
                      class="mainRadio"
                    />
                    <label for="company">{{ $t("auth.company") }}</label>
                  </div>
                </div>
                <div class="all-container-type">
                  <h6 class="styleOnly mb-3">styleOnly</h6>
                  <div class="flex-sm-gap">
                    <input
                      type="radio"
                      id="person"
                      ref="person"
                      value="person"
                      name="type"
                      class="mainRadio"
                    />
                    <label for="person">{{ $t("auth.person") }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="main-input-cont mt-1">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t("auth.userAr") }}</h6>
              <v-text-field
                type="text"
                name="name[ar]"
                :rules="defaultRoles"
                :placeholder="$t('auth.userphase')"
              ></v-text-field>
            </div>
            <div class="main-input-cont mt-1">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t("auth.userEn") }}</h6>
              <v-text-field
                type="text"
                name="name[en]"
                :rules="defaultRoles"
                :placeholder="$t('auth.userphase')"
              ></v-text-field>
            </div>
            <!-- <div class="main-input-cont mt-1">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t("auth.email") }}</h6>
              <v-text-field
                type="email"
                name="email"
                :rules="defaultRoles"
                :placeholder="$t('auth.emailphase')"
              ></v-text-field>
            </div> -->
            <div class="main-input-cont mt-1 tel-input-me">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t("auth.phone") }}</h6>
              <v-text-field
                v-model="phone"
                type="number"
                min="0"
                name="phone"
                :rules="phoneRules"
                :placeholder="$t('auth.phoneplace')"
              ></v-text-field>
              <div class="drop-countries">
                <Dropdown
                  v-model="selectedCountry"
                  :options="countries"
                  optionLabel="name"
                >
                  <template #value="slotProps">
                    <div v-if="slotProps.value" class="flex-group-me">
                      <img
                        :alt="slotProps.value.label"
                        :src="slotProps.value.image"
                        :class="`mr-2 flag flag-${slotProps.value.key.toLowerCase()}`"
                        style="width: 24px"
                      />
                      <div>{{ slotProps.value.key }}</div>
                    </div>
                    <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                  </template>
                  <template #option="slotProps">
                    <div class="flex-group-me">
                      <img
                        :alt="slotProps.option.label"
                        :src="slotProps.option.image"
                        :class="`mr-2 flag flag-${slotProps.option.key.toLowerCase()}`"
                        style="width: 24px"
                      />
                      <div>{{ slotProps.option.key }}</div>
                    </div>
                  </template>
                </Dropdown>
              </div>
            </div>
            <div class="main-input-cont mb-4">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t("auth.city") }}</h6>
              <Dropdown
                v-model="selectedCity"
                :options="cities"
                filter
                optionLabel="name"
                :placeholder="$t('auth.cityphase')"
                :emptyFilterMessage="$t('noData.noDataToShow')"
                :emptyMessage="$t('noData.noDataToShow')"
                class="main-select"
              />
            </div>
            <div class="main-input-cont mt-1" @click="showMap = true">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t('auth.location') }}</h6>
              <v-text-field
                type="text"
                v-model="address"
                :rules="defaultRoles"
                :placeholder="$t('auth.locationPhase')"
              ></v-text-field>
              <div class="absLeft pointer-none">
                <i class="fa-solid fa-map-pin"></i>
              </div>
            </div>
            <div class="main-input-cont mt-1">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t('auth.bioAr') }}</h6>
              <v-textarea
                :rules="defaultRoles"
                rows="7"
                name="bio[ar]"
                :placeholder="$t('auth.bioArphase')"
              ></v-textarea>
            </div>
            <div class="main-input-cont mt-1">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t('auth.bioEn') }}</h6>
              <v-textarea
                :rules="defaultRoles"
                rows="7"
                name="bio[en]"
                :placeholder="$t('auth.bioEnphase')"
              ></v-textarea>
            </div>
            <div class="main-input-cont mt-1">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t('auth.tradeNum') }}</h6>
              <v-text-field
                type="number"
                :rules="defaultRoles"
                name="commercial_id"
                :placeholder="$t('auth.tradeNumphase')"
              ></v-text-field>
            </div>

            <div class="main-input-cont mt-1">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t('auth.password') }}</h6>
              <v-text-field
                v-model="password"
                type="password"
                name="password"
                :rules="passwordRoles"
                :placeholder="$t('auth.passwordplace')"
              ></v-text-field>
              <div class="absLeft pointer-click" @click="toogleEyeIcon($event)">
                <div class="normalEye">
                  <i class="fa-regular fa-eye"></i>
                </div>
                <div class="slashedEye">
                  <i class="fa-regular fa-eye-slash"></i>
                </div>
              </div>
            </div>
            <div class="main-input-cont mt-1">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t('auth.passwordconfirm') }}</h6>
              <v-text-field
                v-model="confirmPassword"
                type="password"
                name="password_confirmation"
                :rules="confirmRules"
                :placeholder="$t('auth.passwordplace')"
              ></v-text-field>
              <div class="absLeft pointer-click" @click="toogleEyeIcon($event)">
                <div class="normalEye">
                  <i class="fa-regular fa-eye"></i>
                </div>
                <div class="slashedEye">
                  <i class="fa-regular fa-eye-slash"></i>
                </div>
              </div>
            </div>
            <button
              type="submit"
              :disabled="disabled"
              class="main-btn up xl w-100 mt-4"
            >
              <div v-if="!disabled">{{ $t('auth.register') }}</div>
              <div class="loading" role="status" v-if="disabled">
                {{ $t('auth.loginLoader') }}

                <div class="spinner-small-white" v-if="disabled"></div>
              </div>
            </button>
            <div class="flex-group-me mt-3">
              <div class="dont-have font14 gray-col">
                {{ $t('auth.haveAccount') }}
                <router-link to="/loginView">{{ $t('auth.login') }}</router-link>
              </div>
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </div>

  <!-- Map modal  -->
  <Dialog v-model:visible="showMap" modal :style="{ width: '50vw' }">
    <h6 class="text-center py-3">العنوان على الخريطة</h6>
    <div class="modal-body-main">
      <div id="map" style="min-height: 300px">
        <GoogleMap
          api-key="AIzaSyCGt8Jhn_NTdYJVqlyNfH5YQUXJyngCVok"
          :language="locale"
          :autocomplete="true"
          @change-address="getAddess"
        />
        <div class="flex-group-me mt-4 mb-4">
          <button class="main-btn up lg" @click="showMap = false">تاكيد</button>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
// imports
import Dialog from "primevue/dialog";
import pageHeader from "../components/pageHeader.vue";
import Dropdown from "primevue/dropdown";
import GoogleMap from "vue-google-maps-ui";
import { ref, onMounted } from "vue";
import axios from "axios";
import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
import i18n from "@/i18n";

// get locale 
const locale = i18n.global.locale;

// reactive state
const toast = useToast();
const disabled = ref(false);
const lat = ref('');
const lng = ref('');
const form = ref(null);
const showMap = ref(false);

const address = ref("");
const selectedCity = ref(null);
const cities = ref([]);
const profileImg = ref(require("../assets/imgs/solia.jpg"));

const valid = ref(false);
const password = ref("");
const confirmPassword = ref("");
const phone = ref("");
const passwordRoles = ref([
  (value) => {
    if (value) return true;

    return i18n.global.t(`auth.passValid`);
  },
]);
const confirmRules = ref([
  (value) => {
    if (value) return true;

    return i18n.global.t(`auth.passValid`);
  },
  (value) => {
    if (value === password.value) return true;

    return i18n.global.t(`auth.passValidId`);
  },
]);
const phoneRules = ref([
  (value) => {
    if (value) return true;

    return i18n.global.t(`auth.phoneValid`);
  },
  (value) => {
    if (value.length >= 9) return true;

    return i18n.global.t(`auth.phoneValidnumber`);
  },
]);
const selectedCountry = ref({
  key: "+966",
  code: "SA",
  image:
    "http://backend.saqf-sa.com/public/storage/images/countries/1704282290_8447.png",
});
const countries = ref([]);
const defaultRoles = ref([
  (value) => {
    if (value) return true;

    return i18n.global.t(`auth.defaultValid`);
  },
]);

const router = useRouter();

function getCities() {
  axios.get("/cities").then((response) => {
    cities.value = response.data.data;
  });
}
function getCountries() {
  axios.get("/countries").then((response) => {
    countries.value = response.data.data;
    selectedCountry.value = response.data.data?.find(
      (country) => country.key == "+966"
    ) || response.data.data[0];
  });
}
function register() {
  disabled.value = true;
  const fd = new FormData(form.value.$el);
  // fd.append("type", SendedVal.value);
  fd.append("country_code", selectedCountry.value.key);
  if (selectedCity.value) {
    fd.append("city_id", selectedCity.value.id);
  }
  fd.append("lang", localStorage.getItem("lang"));
  fd.append("lat", lat.value);
  fd.append("lng", lng.value);
  fd.append("map_desc", address.value);

  axios.post("/manager/sign-up", fd).then((response) => {
    if (response.data.key == "success") {
      localStorage.setItem("phone", phone.value);
      localStorage.setItem("country_code", selectedCountry.value.key);
      localStorage.setItem("country_img", selectedCountry.value.image);
      localStorage.setItem("userImg", profileImg.value);
      toast.add({
        severity: "success",
        detail: `${response.data.msg}`,
        life: 3000,
      });
      router.push("/keyCode");
    } else {
      toast.add({
        severity: "error",
        detail: `${response.data.msg}`,
        life: 3000,
      });
    }
    disabled.value = false;
  });
}
function ValidRegister() {
  if (valid.value) {
    register();
  } else {
    scrollToDanger();
  }
}
// get agress from map
function getAddess(e) {
  address.value = e.address;
  lat.value = e.info.geometry.location.lat();
  lng.value = e.info.geometry.location.lng();
}
// scroll to un valid input
function scrollToDanger() {
  var element = document.querySelector(".v-input--error");
  if (element) {
    element.querySelector("input").focus();
  }
}
// upload new profile img
function uploadImage(e) {
  const file = e.target.files[0];
  if (e.target.files[0]) {
    profileImg.value = URL.createObjectURL(file);
  } else {
    profileImg.value = require("../assets/imgs/natural-marble-pattern-background.png");
  }
}
// toggle input type
function toogleEyeIcon(event) {
  event.currentTarget.classList.toggle("toggleEye");
  let currentType = event.currentTarget.previousElementSibling
    .querySelector("input")
    .getAttribute("type");
  console.log(currentType);
  if (currentType == "text") {
    event.currentTarget.previousElementSibling
      .querySelector("input")
      .setAttribute("type", "password");
  } else {
    event.currentTarget.previousElementSibling
      .querySelector("input")
      .setAttribute("type", "text");
  }
}
// lifecycle hooks
onMounted(() => {
  getCities();
  getCountries();
});
</script>
